module.exports = __webpack_public_path__ + "static/img/peopel.5bf4b190.png";